/* eslint-disable @typescript-eslint/naming-convention */
import type { N8nLocale } from '../../types';

export default {
	'generic.retry': 'Retry',
	'generic.cancel': 'Cancel',
	'generic.close': 'Close',
	'generic.moreInfo': 'More info',
	'aiModelSelector.credentialsMissing': 'Credentials missing',
	'nds.auth.roles.owner': 'Owner',
	'nds.userInfo.you': '(you)',
	'nds.userSelect.selectUser': 'Select User',
	'nds.userSelect.noMatchingUsers': 'No matching users',
	'nds.inputNumber.increase': 'Increase',
	'nds.inputNumber.decrease': 'Decrease',
	'notice.showMore': 'Show more',
	'notice.showLess': 'Show less',
	'formInput.validator.fieldRequired': 'This field is required',
	'formInput.validator.minCharactersRequired': 'Must be at least {minimum} characters',
	'formInput.validator.maxCharactersRequired': 'Must be at most {maximum} characters',
	'formInput.validator.oneNumbersRequired': (config: { minimum: number }) => {
		return `Must have at least ${config.minimum} number${config.minimum > 1 ? 's' : ''}`;
	},
	'formInput.validator.validEmailRequired': 'Must be a valid email',
	'formInput.validator.uppercaseCharsRequired': (config: { minimum: number }) =>
		`Must have at least ${config.minimum} uppercase character${config.minimum > 1 ? 's' : ''}`,
	'formInput.validator.defaultPasswordRequirements':
		'{minimum}+ characters, at least 1 number and 1 capital letter',
	'sticky.markdownHint':
		'You can style with <a href="https://docs.n8n.io/workflows/components/sticky-notes/" target="_blank">Markdown</a>',
	'tags.showMore': (count: number) => `+${count} more`,
	'datatable.pageSize': 'Page size',
	'pagination.previousPage': 'Previous page',
	'pagination.nextPage': 'Next page',
	'pagination.total': 'Total {total}',
	'pagination.pageSize': 'Page size',
	'pagination.pageSizeOption': '{size}/page',
	'pagination.goTo': 'Go to',
	'pagination.goToPage': 'Go to page',
	'codeDiff.couldNotReplace': 'Could not replace code',
	'codeDiff.codeReplaced': 'Code replaced',
	'codeDiff.replaceMyCode': 'Replace my code',
	'codeDiff.replacing': 'Replacing...',
	'codeDiff.undo': 'Undo',
	'generic.copy': 'Copy',
	'generic.copiedToClipboard': 'Copied to clipboard',
	'codeBlock.copy': 'Copy code',
	'codeBlock.copiedToClipboard': 'Copied to clipboard',
	'codeBlock.copyFailed': "Couldn't copy code. Try again or copy it manually.",
	'codeBlock.expand': 'Expand code',
	'codeBlock.collapse': 'Collapse code',
	'previewTag.preview': 'Preview',
	'askAssistantButton.askAssistant': 'n8n AI',
	'assistantChat.builder.name': 'AI Builder',
	'assistantChat.builder.generatingFinalWorkflow': 'Generating final workflow...',
	'assistantChat.builder.configuredNodes': 'Configured nodes',
	'assistantChat.builder.thumbsUp': 'Helpful',
	'assistantChat.builder.thumbsDown': 'Not helpful',
	'assistantChat.builder.feedbackPlaceholder': 'Tell us about your experience',
	'assistantChat.builder.success': 'Thanks for your feedback!',
	'assistantChat.builder.feedbackSubmit': 'Submit feedback',
	'assistantChat.rating.thumbsUp': 'Helpful',
	'assistantChat.rating.thumbsDown': 'Not helpful',
	'assistantChat.rating.feedbackPlaceholder': 'Tell us about your experience',
	'assistantChat.rating.success': 'Thanks for your feedback!',
	'assistantChat.rating.feedbackSubmit': 'Submit feedback',
	'assistantChat.builder.workflowGenerated1': 'Your workflow was created successfully!',
	'assistantChat.builder.workflowGenerated2': 'Fix any missing credentials before testing it.',
	'assistantChat.builder.configuringNodes': 'Configuring nodes...',
	'assistantChat.builder.selectedNodes': 'Selected workflow nodes',
	'assistantChat.builder.selectingNodes': 'Selecting nodes...',
	'assistantChat.builder.generatedNodes': 'Generated workflow nodes',
	'assistantChat.builder.toolRunning': 'Tool still running',
	'assistantChat.builder.toolError': 'Some tool calls have failed. Agent will retry these.',
	'assistantChat.thinking.workflowGenerated': 'Workflow generated',
	'assistantChat.thinking.craftingWorkflow': 'Crafting workflow',
	'assistantChat.thinking.thinking': 'Thinking',
	'assistantChat.thinking.processing': 'Processing',
	'assistantChat.errorParsingMarkdown': 'Error parsing markdown content',
	'assistantChat.aiAssistantLabel': 'n8n AI',
	'assistantChat.aiAssistantBetaLabel': 'Beta',
	'assistantChat.aiAssistantName': 'n8n AI',
	'assistantChat.sessionEndMessage.1':
		'This n8n AI session has ended. To start a new session with n8n AI, click a',
	'assistantChat.sessionEndMessage.2': 'button in n8n',
	'assistantChat.you': 'You',
	'assistantChat.quickRepliesTitle': 'Quick reply 👇',
	'assistantChat.placeholder.1': () =>
		'I can answer most questions about building workflows in n8n.',
	'assistantChat.placeholder.2': 'For specific tasks, you’ll see the',
	'assistantChat.placeholder.3': 'button in the UI.',
	'assistantChat.placeholder.4': 'How can I help?',
	'assistantChat.inputPlaceholder': 'Enter your response...',
	'assistantChat.blankStateInputPlaceholder': 'What would you like to automate?',
	'assistantChat.copy': 'Copy',
	'assistantChat.copied': 'Copied',
	'assistantChat.characterLimit': "You've reached the {limit} character limit",
	'aiAssistant.builder.canvas.thinking': 'Working...',
	'aiAssistant.builder.streamAbortedMessage': 'Task aborted',
	'collaboration.canvas.acquireEditing': 'Edit here',
	'collaboration.canvas.editing': '{user} is currently editing',
	'collaboration.canvas.editingAnotherTab': 'Editing in another tab',
	'inlineAskAssistantButton.asked': 'Asked',
	'iconPicker.button.defaultToolTip': 'Choose icon',
	'iconPicker.tabs.icons': 'Icons',
	'iconPicker.tabs.emojis': 'Emojis',
	'iconPicker.search.placeholder': 'Search...',
	'iconPicker.search.noResults': 'No results found',
	'iconPicker.loading': 'Loading...',
	'iconPicker.random.icon': 'Pick a random icon',
	'iconPicker.random.emoji': 'Pick a random emoji',
	'iconPicker.colorPicker.tooltip': 'Icon color',
	'iconPicker.colorPicker.selectColor': 'Select icon color',
	'iconPicker.skinTone.tooltip': 'Skin tone',
	'iconPicker.skinTone.selectSkinTone': 'Select skin tone',
	'iconPicker.skinTone.default': 'Default',
	'iconPicker.skinTone.light': 'Light',
	'iconPicker.skinTone.mediumLight': 'Medium-Light',
	'iconPicker.skinTone.medium': 'Medium',
	'iconPicker.skinTone.mediumDark': 'Medium-Dark',
	'iconPicker.skinTone.dark': 'Dark',
	'iconPicker.colorPicker.blue': 'Blue',
	'iconPicker.colorPicker.lightBlue': 'Light Blue',
	'iconPicker.colorPicker.azure': 'Azure',
	'iconPicker.colorPicker.purple': 'Purple',
	'iconPicker.colorPicker.pink': 'Pink',
	'iconPicker.colorPicker.red': 'Red',
	'iconPicker.colorPicker.orange': 'Orange',
	'iconPicker.colorPicker.green': 'Green',
	'iconPicker.colorPicker.darkGreen': 'Dark Green',
	'iconPicker.colorPicker.gray': 'Gray',
	'iconPicker.category.all': 'All',
	'iconPicker.iconSection.accessibility': 'Accessibility',
	'iconPicker.iconSection.account': 'Accounts & Access',
	'iconPicker.iconSection.animals': 'Animals',
	'iconPicker.iconSection.arrows': 'Arrows',
	'iconPicker.iconSection.brands': 'Brands',
	'iconPicker.iconSection.buildings': 'Buildings',
	'iconPicker.iconSection.charts': 'Charts',
	'iconPicker.iconSection.communication': 'Communication',
	'iconPicker.iconSection.connectivity': 'Connectivity',
	'iconPicker.iconSection.cursors': 'Cursors',
	'iconPicker.iconSection.design': 'Design',
	'iconPicker.iconSection.development': 'Coding & Development',
	'iconPicker.iconSection.devices': 'Devices',
	'iconPicker.iconSection.emoji': 'Emoji',
	'iconPicker.iconSection.files': 'File Icons',
	'iconPicker.iconSection.finance': 'Finance',
	'iconPicker.iconSection.foodBeverage': 'Food & Beverage',
	'iconPicker.iconSection.gaming': 'Gaming',
	'iconPicker.iconSection.home': 'Home',
	'iconPicker.iconSection.layout': 'Layout',
	'iconPicker.iconSection.mail': 'Mail',
	'iconPicker.iconSection.math': 'Mathematics',
	'iconPicker.iconSection.medical': 'Medical',
	'iconPicker.iconSection.multimedia': 'Multimedia',
	'iconPicker.iconSection.nature': 'Nature',
	'iconPicker.iconSection.navigation': 'Navigation, Maps & POIs',
	'iconPicker.iconSection.notifications': 'Notifications',
	'iconPicker.iconSection.people': 'People',
	'iconPicker.iconSection.photography': 'Photography',
	'iconPicker.iconSection.science': 'Science',
	'iconPicker.iconSection.seasons': 'Seasons',
	'iconPicker.iconSection.security': 'Security',
	'iconPicker.iconSection.shapes': 'Shapes',
	'iconPicker.iconSection.shopping': 'Shopping',
	'iconPicker.iconSection.social': 'Social',
	'iconPicker.iconSection.sports': 'Sports',
	'iconPicker.iconSection.sustainability': 'Sustainability',
	'iconPicker.iconSection.text': 'Text Formatting',
	'iconPicker.iconSection.time': 'Time & Calendar',
	'iconPicker.iconSection.tools': 'Tools',
	'iconPicker.iconSection.transportation': 'Transportation',
	'iconPicker.iconSection.travel': 'Travel',
	'iconPicker.iconSection.weather': 'Weather',
	'iconPicker.iconSection.other': 'Other',
	'iconPicker.emojiSection.people': 'Smileys & People',
	'iconPicker.emojiSection.animalsNature': 'Animals & Nature',
	'iconPicker.emojiSection.foodDrink': 'Food & Drink',
	'iconPicker.emojiSection.activity': 'Activity',
	'iconPicker.emojiSection.travelPlaces': 'Travel & Places',
	'iconPicker.emojiSection.objects': 'Objects',
	'iconPicker.emojiSection.symbols': 'Symbols',
	'iconPicker.emojiSection.flags': 'Flags',
	'actionDropdown.activator': 'Actions',
	'askAssistantChat.close': 'Close',
	'sendStopButton.stop': 'Stop',
	'sendStopButton.send': 'Send',
	'selectableList.addDefault': '+ Add a',
	'auth.changePassword.passwordsMustMatchError': 'Passwords must match',
	'tableControlsButton.display': 'Display',
	'tableControlsButton.shown': 'Shown',
	'tableControlsButton.hidden': 'Hidden',
	'promptInput.creditsInfo': '<b>{remaining}/{total}</b> monthly credits left',
	'promptInput.getMore': 'Get more',
	'promptInput.askAdminToUpgrade': 'Ask your admin to upgrade the instance to get more credits',
	'promptInput.characterLimitReached': "You've reached the {limit} character limit",
	'promptInput.remainingCredits': 'Remaining builder AI credits: <b>{count}</b>',
	'promptInput.monthlyCredits': 'Monthly credits: <b>{count}</b> (1 credit = 1 message)',
	'promptInput.creditsRenew': 'Credits renew on: <b>{date}</b>',
	'promptInput.creditsExpire': 'Unused credits expire {date}',
	'nodeCreatorNode.new': 'New',
	'collapsiblePanel.collapse': 'Collapse',
	'collapsiblePanel.expand': 'Expand',
	'collapsiblePanel.dragToReorder': 'Drag to reorder',
	'collapsiblePanel.delete': 'Delete',
	'combobox.clearSelection': 'Clear selection',
	'combobox.showPopup': 'Show popup',
	'combobox.placeholder': 'Select an option',
	'combobox.emptyText': 'No results found.',
	'tagsInput.removeTag': 'Remove {tag}',
	'markdownEditor.bold': 'Bold',
	'markdownEditor.italic': 'Italic',
	'markdownEditor.strikethrough': 'Strikethrough',
	'markdownEditor.underline': 'Underline',
	'markdownEditor.link': 'Link',
	'markdownEditor.bulletList': 'Bullet list',
	'markdownEditor.orderedList': 'Ordered list',
	'markdownEditor.taskList': 'Task list',
	'markdownEditor.codeBlock': 'Code block',
	'markdownEditor.blockquote': 'Blockquote',
	'markdownEditor.undo': 'Undo',
	'markdownEditor.redo': 'Redo',
	'markdownEditor.text': 'Text',
	'markdownEditor.heading1': 'Heading 1',
	'markdownEditor.heading2': 'Heading 2',
	'markdownEditor.heading3': 'Heading 3',
	'markdownEditor.rawMarkdownView': 'Raw markdown',
	'markdownEditor.formattedMarkdownView': 'Formatted view',
	'markdownEditor.linkDialogTitle': 'Add link',
	'markdownEditor.linkUrl': 'Link URL',
	'markdownEditor.linkPlaceholder': 'https://example.com',
	'markdownEditor.linkRequired': 'Enter a URL to add the link',
	'markdownEditor.linkInvalid': 'Enter a valid URL, such as https://example.com',
	'markdownEditor.addLink': 'Add link',
	'markdownEditor.updateLink': 'Update link',
	'markdownEditor.removeLink': 'Remove link',
	'markdownEditor.cancel': 'Cancel',
	'markdownEditor.slashCommandMenuLabel': 'Markdown commands',
	'aiAssistant.textMessage.restoreVersion': 'Restore version',
	'aiAssistant.versionCard.restoreModal.title': 'Restore to this version?',
	'aiAssistant.versionCard.restoreModal.description':
		'Your current version will be saved in version history for {pruneTime}.',
	'aiAssistant.versionCard.restoreModal.descriptionNoLimit':
		'Your current version will be saved in version history.',
	'aiAssistant.versionCard.restoreModal.hour': '{count} hour',
	'aiAssistant.versionCard.restoreModal.hours': '{count} hours',
	'aiAssistant.versionCard.restoreModal.day': '{count} day',
	'aiAssistant.versionCard.restoreModal.days': '{count} days',
	'aiAssistant.versionCard.restoreModal.showVersion': 'Show version',
	'aiAssistant.versionCard.restoreModal.restore': 'Restore',
} as N8nLocale;
